import { styled } from '@mui/material';

export const StyledGradient = styled('div')(({ theme }) => ({
  background: `linear-gradient(to right, ${theme.palette.custom.gradient[50]}, ${theme.palette.custom.gradient[900]})`,
  paddingTop: theme.spacing(2),
  [theme.breakpoints.only('mobile')]: {
    display: 'none'
  }
}));
